import { takeLatest, call, put, select, takeEvery } from 'redux-saga/effects'
import Api from '../../api'
import { authBulkCapturePayment } from 'portal-modules/payments/api/api'
import { handleResponseError } from '../create-request-saga'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { addError } from 'portal-modules/common/redux/modules/errors'
import { CUSTOM_JWT_STORAGE_KEY } from 'portal-modules/common/constants/keys'
import { localStorage as local } from '@entrata/utils'

import { resetValidatePayments } from 'portal-modules/payments/redux/modules/bulkValidatePayments'
import { requestBalanceDue } from 'portal-modules/common/redux/modules/balanceDue'

import { clearBulkPaymentDetails } from 'portal-modules/payments/components/bulk-payments/redux/modules/bulkPayment'
// action types
const RECEIVE_BULK_PAYMENTS_LIST =
  'rp/BulkPaymentsList/RECEIVE_BULK_PAYMENTS_LIST'
const REQUEST_BULK_PAYMENTS_LIST =
  'rp/BulkPaymentsList/REQUEST_BULK_PAYMENTS_LIST'
const INSERT_BULK_PAYMENTS = 'rp/BulkPaymentsList/INSERT_BULK_PAYMENTS'
const UPDATE_BULK_PAYMENT_STATUS =
  'rp/BulkPaymentsList/UPDATE_BULK_PAYMENT_STATUS'

const intialState = {
  bulkPayments: [],
  complete: false,
  processedBulkPayments: {},
}

// reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case RECEIVE_BULK_PAYMENTS_LIST:
      return state?.bulkPayments
        ? {
            bulkPayments: { ...state.bulkPayments, ...payload },
            complete:
              Object.values(payload).length < 25 ||
              Object.values(payload).length == 0,
            processedBulkPayments: {},
          }
        : {
            bulkPayments: { ...payload },
            complete: false,
            processedBulkPayments: {},
          }
    case UPDATE_BULK_PAYMENT_STATUS:
      var leaseKey = Object.keys(payload)[0]
      var bulkPaymentStatus = {}
      if (Object.keys(state?.processedBulkPayments).length) {
        bulkPaymentStatus = { ...state.processedBulkPayments }
      }

      bulkPaymentStatus[leaseKey] = payload[leaseKey]
      var newBulkPayments = { ...state.bulkPayments }
      return {
        bulkPayments: newBulkPayments,
        complete: state.complete,
        processedBulkPayments: bulkPaymentStatus,
      }
    default:
      return state
  }
}

// action creators
export const requestBulkPaymentsList = payload => ({
  type: REQUEST_BULK_PAYMENTS_LIST,
  payload,
})

export const receiveBulkPaymentsList = payload => ({
  type: RECEIVE_BULK_PAYMENTS_LIST,
  payload,
})

export const processBulkPayment = payload => ({
  type: INSERT_BULK_PAYMENTS,
  payload,
})

export const updateBulkPaymentStatus = payload => ({
  type: UPDATE_BULK_PAYMENT_STATUS,
  payload,
})

// sagas
function* fetchBulkPaymentsList({ payload }) {
  try {
    const {
      userSettings: { isBulkPayment },
    } = yield select()
    const { payments } = yield call(Api.getBulkPaymentsList, {
      items_per_page: payload.items_per_page,
      page: payload.page,
      is_bulk_payment_workflow: isBulkPayment,
    })
    var bulkPaymentsList = []
    Object.keys(payments).forEach((key, index) => {
      bulkPaymentsList[payload.page + '_' + index] = payments[key]
    })
    yield put(receiveBulkPaymentsList(bulkPaymentsList))
  } catch (error) {
    yield call(handleResponseError, error, { key: 'bulkPaymentsList' })
  }
}

function* insertBulkPayments({ payload }) {
  const { paymentMethod, data, callback } = payload

  let responseData = {}
  const { amount, paymentGroupId } = data
  const { id, payment_type_id, last_used, nickname, card_info } = paymentMethod

  try {
    const dataPayment = {
      id: id,
      payment_amounts: [
        {
          amount: amount,
          merchant_account_id: 0,
        },
      ],
      agrees_to_terms: true,
      agrees_to_fees: true,
      agrees_to_duplicate: data.agreesToDuplicate,
      terms_accepted_on: new Date().toISOString(),
      cvv_code: '',
      customer_payment_account_id: id,
      payment_type_id: payment_type_id,
      last_used: last_used,
      nickname: nickname,
      card_info: card_info,
      payment_group_id: paymentGroupId,
      ...data.fixedPayload,
    }

    yield call(local.set, CUSTOM_JWT_STORAGE_KEY, data.token)

    const response = yield call(authBulkCapturePayment, dataPayment)

    if (Object.keys(response).length) {
      responseData[data.lease_id] = { ...response }
      yield put(updateBulkPaymentStatus(responseData))
      yield put(
        requestBalanceDue({
          token: data.token,
          leaseId: data.lease_id,
        }),
      )
      yield put(clearBulkPaymentDetails())
    }

    if (callback && callback != null && typeof callback == 'function') {
      yield put(resetValidatePayments())
      callback()
    }
  } catch (error) {
    responseData[data.lease_id] = {
      payments: false,
      errorInfo: error,
      error: error?.response?.data?.message || '',
      total_amount: data.amount,
    }

    yield put(updateBulkPaymentStatus(responseData))

    if (callback && callback != null && typeof callback == 'function') {
      yield put(resetValidatePayments())
      callback()
    }
  }
}

function* handleBulkPaymentsError({ message }, { key, action }) {
  action.payload &&
    'function' === typeof action.payload.onError &&
    action.payload.onError()
  yield put(addError({ key, message }))
}

function* watchBulkPaymentsList() {
  yield takeLatest(
    REQUEST_BULK_PAYMENTS_LIST,
    createRequestSaga(fetchBulkPaymentsList, {
      key: 'bulk_payments',
      messgae: __('Looking up payment settings'),
      duration: 500,
    }),
  )
}

function* watchProcessList() {
  yield takeEvery(
    INSERT_BULK_PAYMENTS,
    createRequestSaga(insertBulkPayments, {
      key: 'bulk_payments',
      messgae: __('Inserting Bulk Payment'),
      duration: 500,
      onError: handleBulkPaymentsError,
    }),
  )
}

export const sagas = [watchBulkPaymentsList, watchProcessList]
